module.exports = __webpack_public_path__ + "static/media/14_tn.53044088.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/14_tn.jpg
// module id = 444
// module chunks = 0